import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import VisionHomePage from "./VisionHomePage";
import ShopPage from "./ShopPage";
import CartPage from "./CartPage";
import PrivacyPolicy from "./PrivacyPolicy";
import { CartProvider } from "./context/CartContext";
import CartSidebar from "./components/CartSidebar";

function App() {
  return (
    <CartProvider>
      <Router>
        <CartSidebar />
        <Routes>
          {/* Hlavní stránka */}
          <Route path="/" element={<VisionHomePage />} />

          {/* E-shop */}
          <Route path="/shop" element={<ShopPage />} />

          {/* Košík */}
          <Route path="/cart" element={<CartPage />} />

          {/* 🔒 Ochrana osobních údajů */}
          <Route
            path="/ochrana-osobnich-udaju"
            element={<PrivacyPolicy />}
          />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;
